import { RouteConfig } from '@abaco/web-common/src/app';
import routesChangeRequests from './routes-change-requests';
import routesPCR from './routes-pcr';
import routesPPR from './routes-ppr';
import routesProjectProposal from './routes-project-proposal';

export type BreadCrumb = { text: string; link?: string };

const routes: RouteConfig[] = [
    {
        path: "/",
        component: () => import("./components/Root.vue"),
        meta: { guest: true },
        children: [
            {
                name: "subjectList",
                path: "/",
                component: () => import("./components/SubjectsList.vue"),
                props: true,
                meta: {
                    breadCrumb(): BreadCrumb[] {
                        return [
                            {
                                text: "subject-list",
                                link: "/"
                            }
                        ];
                    }
                },
            },
            {
                name: "contractsList",
                path: "/subject/:subjectId/contracts",
                component: () => import("./components/ContractsList.vue"),
                props: true,
                meta: {
                    breadCrumb(params: { [key: string]: string }, isSingleSubject = true): BreadCrumb[] {

                        const ret: BreadCrumb[] = [];
                        if (!isSingleSubject) {

                            ret.push({
                                text: "subject-list",
                                link: "/"
                            });
                        }

                        ret.push({
                            text: "contracts-list",
                            link: `/subject/${encodeURIComponent(params.subjectId)}/contracts`
                        });

                        return ret;

                    }
                }
            },
            {
                name: "login",
                path: "/login",
                component: () => import("./components/Login.vue"),
                props: true,
                meta: {
                    guest: true,
                    breadCrumb(): BreadCrumb[] {
                        return [];
                    }
                }
            },
            ...routesPPR,
            ...routesPCR,
            ...routesChangeRequests,
            ...routesProjectProposal,
            {
                name: "e404",
                path: "*",
                component: () => import("./components/E404.vue"),
                props: true,
            },
        ]

    },
];

export default routes;
